import { ToggleButtonGroup } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledViewModeToggle = styled(ToggleButtonGroup)(({ theme }) => ({
  height: '40px',
  '& .MuiToggleButton-root': {
    border: `1px solid ${theme.palette.divider}`,
    padding: '6px 12px',
    color: theme.palette.text.secondary,
    '& .material-symbols-outlined': {
      fontSize: '22px',
    },
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    '&.Mui-selected': {
      color: '#FAFCFF',
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
        opacity: 0.85,
      },
    },
    '&.Mui-disabled': {
      opacity: 0.4,
    },
  },
}));
